import styled from '@emotion/styled';
import { breakpoints, getClampFullRange } from '~/theme';
import { Text } from '~/shared/components';

export const StyledReserveReceiptStore = styled.div(({ theme }) => ({
    padding: `${getClampFullRange(theme.spacesRaw[3], theme.spacesRaw[4])} 0`,
    marginBottom: theme.spaces[4],
}));

export const StyledReceiptInfo = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spaces[4],
    [breakpoints.sm]: {
        flexDirection: 'row',
    },
}));

export const StyledReceiptStoreInfo = styled.div({
    [breakpoints.sm]: {
        flex: '1 1 35%',
    },
});

export const StyledOpeningHoursWrapper = styled.div(({ theme }) => ({
    [breakpoints.sm]: {
        flex: '1 0 auto',
        padding: `0 ${theme.spaces[3]}`,
        borderLeft: theme.traits.line.asBorderStyle,
    },

    caption: {
        fontWeight: theme.fontWeights.bold,
    },
}));

export const StyledReceiptMediumText = styled(Text)(({ theme }) => ({
    fontWeight: theme.fontWeights.medium,
}));
